<template>
    <section class="about">
          <div class="block"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>blockwhite</title><polygon points="1920 0 0 480 0 0 1920 0" /></svg></div>
          <div class="main">
            <!--wallpattern-->
            <div class="wallpattern"><img src="../../asset/svg/wallpattern.svg" alt=""></div>
            <div class="bookmark"><img src="../../asset/svg/bookmark/v/about.svg" alt="關於多寶"></div>
            <div class="txtcontent strip">
              <h2 class="wow1"><img src="../../asset/svg/title/about1.svg" alt="多寶藝術學堂"><br class="desktop_only"><img src="../../asset/svg/title/about2.svg" alt="在做什麼?" class="secondtxt"></h2>
              <p class="wow2"> <b>給「泛自閉症青年」一間連結未來的學校</b><br>在關渡一個二十坪小小空間，可以容納他們想要的夢想<br>「永遠的生命學習的地方」</p>
              <a href="javascript:void(0)" class="btn wow3" v-on:click="childOpen()">
                <!--videoicon-->
                <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.47 28.79"><title>video</title><g data-name="video"><path d="M36.28,3.63a1.91,1.91,0,0,0,2.35-1.47.62.62,0,0,0,0-.34A1.65,1.65,0,0,0,37.38.94a16,16,0,0,0-2.8-.41c-2.77-.15-5.92-.31-9-.38C18.37,0,10.91-.16,3.44.34.86.51.06,1,0,3.78,0,10.67,0,17.59,0,22.84a20.44,20.44,0,0,0,.27,2.78c.05.36.1.71.15,1.07a1.76,1.76,0,0,0,1.75,1.67c.44,0,.88.07,1.33.12.59.06,1.18.12,1.78.14q5.85.18,11.67.18c5.3,0,10.56-.11,15.74-.33a33.42,33.42,0,0,0,3.85-.4c1.56-.25,1.89-.76,2.09-2.18a93.72,93.72,0,0,0,.74-15.81A12,12,0,0,0,39,7.39a1.62,1.62,0,0,0-1.64-1,1.25,1.25,0,0,0-.92.63,1.49,1.49,0,0,0,0,1.32,1.52,1.52,0,0,1,.14.58v2.31c0,2.59,0,5.26-.07,7.88,0,1.2-.16,2.43-.28,3.62-.08.84-.17,1.68-.23,2.52,0,.08,0,.13,0,.14l-.2,0-1.61.13c-1,.09-2,.18-3.06.19-6.84.07-14.23.12-23.24.16-1,0-2.07,0-3.08-.09l-1.69-.07H3a7.6,7.6,0,0,0-.07-1c0-.23-.06-.47-.06-.7l-.07-3.27c-.09-4.16-.19-8.45-.23-12.68,0-1.23.07-2.46.15-3.76,0-.4.05-.8.08-1.2A283.66,283.66,0,0,1,35,3.31Z" /><path d="M16,21.77A2.93,2.93,0,0,1,13,18.84V8.8A2.93,2.93,0,0,1,17.6,6.37l7.52,5a2.93,2.93,0,0,1,0,4.88l-7.52,5A2.92,2.92,0,0,1,16,21.77ZM16,8.28a.53.53,0,0,0-.25.06.5.5,0,0,0-.28.46v10a.51.51,0,0,0,.28.46.51.51,0,0,0,.54,0l7.52-5a.53.53,0,0,0,0-.88l-7.51-5A.54.54,0,0,0,16,8.28Z" /></g></svg></div><span>關於多寶願景</span></a>
            </div>
            <div class="whattodo">
              <ul>
                <li>
                  <div class="featurepic wow1"><img src="../../img/whattodo1.jpg" alt=""></div>
                  <div class="wow2">
                    <h3>延續藝術創作</h3>
                    <p>多寶的創作人（泛自閉症青年）在多寶學堂擁有自己專屬的工作區域，接受量身規劃的多元學習，繼續自己從小一直熱愛的藝術創作。</p>
                  </div>
                </li>
                <li>
                  <div class="featurepic wow3"><img src="../../img/whattodo2.jpg" alt=""></div>
                  <div class="wow4"><h3>生活美學與能力</h3>
                  <p>每年寫生旅行、電影欣賞、美術館參觀、餐桌上的哲學課、佈置生活環境，簡單至煎一顆荷包蛋、手沖好咖啡，從大自然到日常生活拓展他們對美的感受。</p></div>
                </li>
                <li>
                  <div class="featurepic wow1"><img src="../../img/whattodo3.jpg" alt=""></div>
                  <div class="wow2"><h3>提升藝術相關技能</h3>
                  <p>提升創作人藝術工作相關技能。創作是獨立的，而藝術領域是寬廣的，與藝術相關產業合作及專業前輩的帶領投入實務學習、自食其力。</p></div>
                </li>
                <li>
                  <div class="featurepic wow3"><img src="../../img/whattodo4.jpg" alt=""></div>
                  <div class="wow4"><h3>搭起社會互動的橋樑</h3>
                  <p>以多寶學堂為連結點，舉辦各種活動，及個人、企業資源整合與管理，增進社會大眾對自閉症青少年的認識，發現因生命的差異帶來與眾不同的美麗。</p></div>
                </li>
              </ul>
              <div class="clear"></div>
            </div>
          </div>
          <!--light-->
          <div class="light"></div>
        </section>
</template>

<script>
      export default {

        methods:{
          childOpen:function(){
            console.log('sent to father');
            gaclick('btn_curiovideo');
            this.$emit('childOpen');
          }
        }
    }
</script>


// WEBPACK FOOTER //
// About.vue?3671d4df